var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "permission-container"
  }, [_c("p", [_vm._v(_vm._s(_vm.$t("当前权限:")) + '["' + _vm._s(_vm.role) + '"]')]), _vm._v(" " + _vm._s(_vm.$t("切换权限：")) + " "), _c("a-radio-group", {
    attrs: {
      "default-value": _vm.role,
      "button-style": "solid"
    },
    on: {
      change: _vm.handleChangeRole
    }
  }, [_c("a-radio-button", {
    attrs: {
      value: "admin"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("admin")) + " ")]), _c("a-radio-button", {
    attrs: {
      value: "editor"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("editor")) + " ")]), _c("a-radio-button", {
    attrs: {
      value: "test"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("test")) + " ")])], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };